module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"es":{},"sw":{}}')
  delete Component.options._Ctor
}
